import React from 'react';
import PurposePage from '../../pages/PurposePage';

const PurposeDesktop = () => <PurposePage />;

export default PurposeDesktop;
